import { render } from "./TodaysData.vue?vue&type=template&id=98cd6a00"
import script from "./TodaysData.vue?vue&type=script&lang=js"
export * from "./TodaysData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__